import UserEventCardComponents from './components/UserEventCardComponents';
import getUserLabelComponents from './components/getUserLabelComponents';
import SlideTab from './components/SlideTab';
import SlideTabVertical from './components/SlideTabVertical';
import getUserLabel from './helpers/getUserLabel';
import addMinutesToDate from './helpers/addMinutesToDate';
import formatDateTime from './helpers/formatDateTime';
import convertMinuteToHour from './helpers/convertMinuteToHour';
import formatCreditCardNumber from './helpers/formatCreditCardNumber';
import checkSubmitData from './helpers/checkSubmitData';
import getUserAge from './helpers/getUserAge';
import nFormatter from './helpers/nFormatter';
import addDaysToDate from './helpers/addDaysToDate';
import validateEmail from './helpers/validateEmail';
import airDatePickerLocale from './helpers/airDatePickerLocale';
import formatDate from './helpers/formatDate';
import clearField from './helpers/clearField';
import stripHtml from './helpers/stripHtml';
import getHtmlImage from './helpers/getHtmlImage';
import humanTime from './helpers/humanTime';
import humanTimeHelper from './helpers/humanTimeHelper';
import setInputError from './helpers/setInputError';
import windowScrollTop from './helpers/windowScrollTop';
import modalScrollTop from './helpers/modalScrollTop';
import userIsSuspended from './helpers/userIsSuspended';
import isMobile from './helpers/isMobile';
import cookies from './helpers/cookies';
export const components = {
  convertMinuteToHour,
  SlideTab,
  SlideTabVertical,
  addMinutesToDate,
  UserEventCardComponents,
  getUserLabelComponents,
  getUserLabel,
  formatDateTime,
  formatCreditCardNumber,
  validateEmail,
  checkSubmitData,
  addDaysToDate,
  nFormatter,
  getUserAge,
  airDatePickerLocale,
  formatDate,
  clearField,
  setInputError,
  windowScrollTop,
  modalScrollTop,
  userIsSuspended,
  isMobile,
  cookies,
  stripHtml,
  getHtmlImage,
  humanTime,
  humanTimeHelper,
  selectedCategory: ""
};
window.zivenCore = components;